<template>
  <div class="page-container">
    <el-row>
      <el-col :span="treeSpan" class="tree-container">
        <TablePageTree
          :title="title"
          style="paddingRight: 10px"
          :placeholder="placeholder"
          :restful="restful"
          @trigger="trigger"
          @change="treeChange"
          :defaultProps="defaultProps"
          ref="tableTree"
        />
      </el-col>
      <el-col :span="contentSpan">
        <el-scrollbar
          wrap-class="tree-scrollbar"
          class="tree-style"
          :native="false"
          view-class="tree-scrollr-container"
          :noresize="false"
          tag="div"
        >
          <component
            :is="treeTable"
            class="table-container"
            :treeCode="treeCode"
            ref="table"
            @resetTrees="reset"
          />
        </el-scrollbar>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import TablePageTree from '../table_page_tree';

export default {
  name: 'tablePageTreeBase',
  components: {
    TablePageTree,
  },
  created() {},
  computed: {},
  methods: {
    treeChange(code) {
      this.treeCode = code;
      this.$refs.table.tablePage.currentPage = 1;
    },
    // 重置
    reset() {
      if (this.treeCode === '') {
        this.$refs.table.getList();
      }
      this.treeCode = '';
      this.$refs.tableTree.getTreeList('reset');
    },
    trigger(show) {
      if (show) {
        this.treeSpan = 4;
        this.contentSpan = 20;
      } else {
        this.treeSpan = 1;
        this.contentSpan = 23;
      }
    },
  },

  data() {
    return {
      treeCode: '',
      treeValue: '',
      treeSpan: 4,
      contentSpan: 20,
      treeTable: 'TablePage',
      placeholder: '请输入',
      title: '',
      restful: '',
      defaultProps: {
        children: 'children',
        label: 'name',
        value: 'code',
        isLeaf: 'isLeaf',
      },
    };
  },
};
</script>
<style lang="less" scoped>
.page-container {
  max-height: calc(100vh - 90px);
  overflow: hidden;
}
.tree-scrollr-container {
  min-height: 300px;
  padding: 0px !important;
  overflow: hidden;
}
.table-container {
  padding: 0 10px;
}
.tree-style {
  height: calc(100vh - 90px);
}
/deep/.tree-container {
  height: 100%;
}
/deep/.tree-scrollbar {
  overflow-x: hidden;
}
/deep/.el-scrollbar__view{
  height: 100%;
}
</style>
